import { gql } from '@apollo/client'

export const CREATE_REPORT = gql`
  mutation ($input: CreateReport) {
    createReport (input: $input) {
        id
    }
  }
`